const lifetime = 48 * 60 * 60 * 1000;

export function migratePrepayProgress<T extends { prepaidOrder?: boolean }>(groupKey: string, legacyKey: string,
  preview: boolean, fromLegacyRoute = false): T | undefined {
  const current = loadActivationProgress<T>(groupKey, preview);
  const legacy = loadActivationProgress<T>(legacyKey, preview);
  if (legacy && (fromLegacyRoute || current?.prepaidOrder === undefined)) {
    const migrated = { ...legacy, prepaidOrder: true, termChosen: true };
    saveActivationProgress(groupKey, preview, migrated);
    clearActivationProgress(legacyKey, preview);
    return migrated;
  }
  return current;
}

export function loadActivationProgress<T>(key: string, preview: boolean): T | undefined {
  try {
    if (!preview) {
      const durable = localStorage.getItem(key);
      if (durable) {
        const stored = JSON.parse(durable);
        if (stored.expiresAt > Date.now() && stored.saved) return stored.saved;
        localStorage.removeItem(key);
        sessionStorage.removeItem(key);
        return undefined;
      }
    }
  } catch {
    // Private browsing/storage restrictions can still allow a same-tab draft.
  }
  try {
    const legacy = sessionStorage.getItem(key);
    return legacy ? JSON.parse(legacy) : undefined;
  } catch {
    return undefined;
  }
}

export function saveActivationProgress<T>(key: string, preview: boolean, saved: T) {
  try {
    if (!preview) {
      localStorage.setItem(key, JSON.stringify({ saved, expiresAt: Date.now() + lifetime }));
      sessionStorage.removeItem(key);
      return;
    }
  } catch {
    // Fall back to session storage when persistent storage is unavailable.
  }
  try {
    sessionStorage.setItem(key, JSON.stringify(saved));
  } catch {
    // Storage failures must not break the customer's current activation.
  }
}

export function clearActivationProgress(key: string, preview: boolean) {
  try {
    sessionStorage.removeItem(key);
  } catch {
    // The in-memory state is reset separately by the activation page.
  }
  if (!preview) {
    try {
      localStorage.removeItem(key);
    } catch {
      // Persistent storage may be unavailable in private browsing.
    }
  }
}
